export const drillThroughSearch = (currentSearch: string, updates: Record<string, string | string[] | null | undefined>): string => {
  const current = new URLSearchParams(currentSearch);
  const search = new URLSearchParams();

  for (const key of ['env', 'start', 'end', 'analysisTypes', 'serviceNames', 'runtimeTypes', 'sources']) {
    const value = current.get(key);
    if (value) {
      search.set(key, value);
    }
  }

  for (const [key, value] of Object.entries(updates)) {
    if (Array.isArray(value) && value.length > 0) {
      search.set(key, value.join(','));
    } else if (typeof value === 'string' && value) {
      search.set(key, value);
    } else {
      search.delete(key);
    }
  }

  return search.toString();
};
